import {ApiProblemDetails} from '../models/shared/api-problem-details.model';

interface HttpErrorLike {
  error?: unknown;
}

export function getApiErrorMessage(error: unknown, fallback: string): string {
  const response = unwrapResponse(error);

  if (isObject(response)) {
    const problem = response as ApiProblemDetails;
    const validationMessages = flattenValidationErrors(problem.errors);
    if (validationMessages.length) return validationMessages.join('\n');

    const detail = cleanMessage(problem.detail);
    if (detail) return detail;

    const legacyMessage = cleanMessage(problem.message);
    if (legacyMessage) return legacyMessage;
  }

  return cleanMessage(response) || fallback;
}

function unwrapResponse(error: unknown): unknown {
  if (isObject(error) && 'error' in error) {
    return (error as HttpErrorLike).error;
  }

  return error;
}

function flattenValidationErrors(errors: ApiProblemDetails['errors']): string[] {
  if (!errors || !isObject(errors)) return [];

  const messages = Object.values(errors)
    .flatMap(value => Array.isArray(value) ? value : [value])
    .map(cleanMessage)
    .filter((message): message is string => !!message);

  return [...new Set(messages)];
}

function cleanMessage(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
